<app-auth-layout>
    @if (!linkEnviado) {
    <!-- 1. Informar email -->
    <div class="auth-stack">
        <button type="button" class="auth-chip-back" (click)="redirectLogin()">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">chevron_left</mat-icon>
            <span>Voltar para o login</span>
        </button>

        <div class="auth-intro">
            <span class="auth-icon-badge" aria-hidden="true">
                <mat-icon class="material-symbols-outlined">lock_reset</mat-icon>
            </span>
            <div class="auth-heading">
                <h1>Esqueceu a senha? Acontece</h1>
                <p>Informe o email da sua conta e enviaremos um link para você criar uma nova senha</p>
            </div>
        </div>

        <form class="auth-form" [formGroup]="model" (ngSubmit)="post()">
            <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <mat-icon matPrefix class="material-symbols-outlined auth-prefix-icon">mail</mat-icon>
                <input matInput formControlName="email" type="email" autocomplete="username"
                    placeholder="seu@email.com.br">
                @if (model.get('email')?.invalid) {
                <mat-error>Informe o seu e-mail cadastrado</mat-error>
                }
            </mat-form-field>

            <button type="submit" mat-flat-button class="btn-primary auth-btn">
                @if (isLoading) {
                <mat-spinner [diameter]="24"></mat-spinner>
                }
                @else {
                <span>Enviar link</span>
                }
                @if (!isLoading) {
                <mat-icon iconPositionEnd class="material-symbols-outlined" aria-hidden="true">send</mat-icon>
                }
            </button>
        </form>
    </div>
    }
    @else {
    <!-- 2. Link enviado -->
    <div class="auth-stack auth-center">
        <span class="auth-icon-badge auth-icon-badge--success" aria-hidden="true">
            <mat-icon class="material-symbols-outlined">mark_email_read</mat-icon>
        </span>

        <div class="auth-heading">
            <h1>Confira o seu email</h1>
            <p>
                Se <strong>{{ emailEscondido }}</strong> estiver cadastrado, você vai receber um link para criar uma
                nova senha
            </p>
        </div>

        <div class="auth-info-box">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">info</mat-icon>
            <span>Não chegou? Verifique a caixa de spam ou lixo eletrônico. Pode levar alguns minutos</span>
        </div>

        <div class="auth-acoes-coluna">
            <button type="button" mat-stroked-button class="auth-btn auth-btn-outline" (click)="post()"
                [disabled]="isLoading">
                @if (isLoading) {
                <mat-spinner [diameter]="24"></mat-spinner>
                }
                @else {
                {{ reenviado ? 'Email reenviado' : 'Reenviar email' }}
                }
            </button>
        </div>

        <button type="button" class="auth-link" (click)="redirectLogin()">Voltar para o login</button>
    </div>
    }
</app-auth-layout>
